<template>
  <div class="sub-menu-wrapper">
    <v-list>
      <v-list-tile @click.stop.prevent="backToMenu" class="menu_close">
        <v-list-tile-action> <v-icon>chevron_left</v-icon> </v-list-tile-action>
        <v-list-tile-title><v-icon v-html="item.icon"></v-icon> {{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list>

    <div class="menu-item"> 
      <v-text-field disabled label="Email:" v-text="user.email"></v-text-field>
    </div>

    <div class="menu-item"> 
      <v-text-field disabled label="Email:" v-text="user.uid"></v-text-field>
    </div>

    <div class="menu-item"> 
      <v-text-field label="Display Name:" :value="user.displayName" @blur="updateUser($event)"></v-text-field>
    </div>
  </div>
</template>

<script>
import { FirebaseAuth } from "../firebase";
import AppState from "../util/AppState";

export default {
  props: ["item"],
  data() {
    return {
      AppState,
      user: FirebaseAuth.currentUser || {}
    };
  },
  methods: {
    backToMenu() {
      this.$emit("backToMenu");
    },
    updateUser(ev) {
      this.AppState.loading = true;
      this.user
        .updateProfile({
          displayName: ev.target.value
        })
        .then(() => {
          this.AppState.loading = false;
        })
        .catch(error => {
          this.AppState.loading = false;
          this.AppState.error.text = error;
          this.AppState.error.show = true;
        });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuAccount.vue